import React from "react";
import { motion } from "framer-motion";

import videoBg from "../assets/video/hero-video.mp4";
import aboutLogo from "../assets/parallex/About.png";
import backgroundImg from "../assets/video/A2.png";

import "./AboutContainer.scss";

const AboutContainer = () => {
  return (
    <div className="about-video-container">
      <video
        autoPlay
        loop
        playsInline
        muted
        poster={backgroundImg}
        className="video-background"
      >
        <source src={videoBg} type="video/mp4" />
        <img src={backgroundImg} alt="" />
      </video>

      <motion.div
        className="about-header"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.4 }}
      >
        <h2>About</h2>
      </motion.div>

      <div className="overlay-container"></div>

      <div className="content">
        <div className="psy-reel-logo">
          <img src={aboutLogo} alt="PsyReel Logo" />
        </div>

        <motion.div
          className="about-content"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.4 }}
        >
          <p>
            <i>The Psy Reel</i> is a team of filmmakers and artists with a
            myriad of unique skills and ideas. Our strength lies in our belief
            in constantly improving our work with creative learning. All of the
            ideas we work on are achieved by creating strategies that are
            simple, clear, and complete.
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default AboutContainer;
